import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import TableCommon from 'common/components/TableCommon';
import { IBaseFilterModel } from 'common/models/requestModels';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getOrderCollection, setOrderCollection } from 'app/store/reducers/order.reducer';
import { IOrderCollectionFilter } from 'entities/Order/Order.models';

interface IComponentProps {
  config: ColumnsType<any>;
  filter: IOrderCollectionFilter;
  updateFilter: (partial: Partial<IOrderCollectionFilter>, options?: any) => void;
}

type AllProps = IComponentProps & RouteComponentProps;

export const FranchiseeOrdersTableComponent: React.FC<AllProps> = ({ config, filter, updateFilter }) => {
  const dispatch = useAppDispatch();
  const { orderCollection, orderCollectionLoading } = useAppSelector((state) => state.order);

  const loadCollection = (params: IBaseFilterModel) => {
    const resultFilter: IOrderCollectionFilter = { ...filter, ...params };
    const { pageIndex, store, dateFrom, dateTo, statuses, promoUsed, bitecoinsUsed, paymentMethod } = resultFilter;

    if (pageIndex) {
      resultFilter.pageIndex = pageIndex;
    }

    if (store) {
      // @ts-ignore
      resultFilter.store = store.id;
    }

    if (dateFrom && dateTo) {
      const formattedDateFrom = moment(dateFrom).format();
      const formattedDateTo = moment(dateTo).endOf('day').format();

      resultFilter.dateFrom = formattedDateFrom;
      resultFilter.dateTo = formattedDateTo;
    }

    if (promoUsed !== undefined) {
      resultFilter.promoUsed = promoUsed;
    }

    if (bitecoinsUsed !== undefined) {
      resultFilter.bitecoinsUsed = bitecoinsUsed;
    }

    if (paymentMethod) {
      resultFilter.paymentMethod = paymentMethod;
    }

    if (statuses) {
      // @ts-ignore
      resultFilter.statuses = statuses;
    }

    dispatch(getOrderCollection(resultFilter));
  };

  const addQuery = (pageIndex: number) => {
    updateFilter({ pageIndex }, { resetPage: false });
  };

  const clearCollection = () => {
    return dispatch(setOrderCollection(null));
  };

  return (
    <TableCommon
      config={config}
      filter={filter}
      collection={orderCollection}
      loading={orderCollectionLoading}
      loadCollection={loadCollection}
      clearCollection={clearCollection}
      addQuery={addQuery}
      scroll={{ x: 'max-content' }}
    />
  );
};

export const FranchiseeOrdersTable = withRouter(FranchiseeOrdersTableComponent);
